const isFunction = (maybeFn) => typeof maybeFn === 'function'
const isString = (maybeString) => typeof maybeString === 'string'
const isArray = (maybeArray) => Array.isArray(maybeArray)

export { isFunction, isString, isArray }
